import {
  isNumber,
  fixNumber
} from '../common/utils'

// 非数字值，取:0
function value_0(value, length) {
  return isNumber(value) ? fixNumber(value, length) : 0;
}

// 非数字值，取:'-'
function value_x(value, length) {
  return isNumber(value) ? fixNumber(value, length) : "-";
}

// 均线无数据，取:'-'
function value_ma(value, length) {
  return value > 0 ? fixNumber(+value, length) : "-";
}

// // cupId int
// // cupName string 名臣
// // cupLogo string logo
// // startTime string 开始时间
// // endTime string 结束时间
// // status int 状态 1 为开始 2进行中 3暂停中 4已结束
// // upDown int 上线下线 1上线 0下线
// // comment string 简介
// function TCup(rawData) {
//     var R = {
//         "cupId": 1,
//         "cupType": "0",
//         "cupName": "自有练功",
//         "cupLogo": "https://imgcdn-dev.pydp888.com/0/1/0/516/d6f1cf50f3481006c0e0c0b73979e722.png",
//         "startTime": "2017-06-07 14:24:16",
//         "endTime": "2017-06-17 14:24:16",
//         "status": 1,
//         "upDown": 1,
//         "comment": "测试数据",
//         "reportStatus": "0",
//         "reportTime": "0000-00-00 00:00:00",
//         "ctime": "2017-06-07 14:24:16",
//         "mtime": "2017-06-09 18:39:57"
//     };
//     R = XUtils.assign(R, rawData);
//     return R;
// }

//K线数据 ： [开盘价 ,收盘价,最低价,最高价,成交额,成交量,[macd,dif,dea],[k,d,j],[ma5,ma10,ma20,ma55,ma89,ma144,ma233,ma377,ma450,ma610]]

export function KLine(rawKLine) {
  var R,
    KDJ,
    MA,
    MACD,
    INDEX_OPEN = 0,
    INDEX_CLOSE = 1,
    INDEX_LOWEST = 2,
    INDEX_HIGHEST = 3,
    INDEX_TURNOVER = 4, //成交额(金额数：元)
    INDEX_VOLUME = 5, //成交量(换手数：股)
    INDEX_MACD = 6,
    INDEX_KDJ = 7,
    INDEX_MA = 8,
    INDEX_TURN_RATE = 9, //换手率
    //INDEX_BOLL = 10,       //BOLL

    INDEX_MACD_MACD = 0,
    INDEX_MACD_DIF = 1,
    INDEX_MACD_DEA = 2,
    INDEX_KDJ_K = 0,
    INDEX_KDJ_D = 1,
    INDEX_KDJ_J = 2,
    INDEX_MA5 = 0,
    INDEX_MA10 = 1,
    INDEX_MA20 = 2,
    INDEX_MA55 = 3,
    INDEX_MA89 = 4,
    INDEX_MA144 = 5,
    INDEX_MA233 = 6,
    INDEX_MA377 = 7,
    INDEX_MA450 = 8,
    INDEX_MA610 = 9;

  rawKLine = rawKLine || [];
  MA = rawKLine[INDEX_MA] || [];
  MACD = rawKLine[INDEX_MACD] || [];
  KDJ = rawKLine[INDEX_KDJ] || [];

  R = {
    open: value_0(rawKLine[INDEX_OPEN], 2),
    close: value_0(rawKLine[INDEX_CLOSE], 2),
    lowest: value_0(rawKLine[INDEX_LOWEST], 2),
    highest: value_0(rawKLine[INDEX_HIGHEST], 2),

    turnover: value_0(rawKLine[INDEX_TURNOVER]), //成交额(金额数：元)
    volume: value_0(rawKLine[INDEX_VOLUME] / 100, 2), //成交量(股=>手)
    turnRate: value_0(rawKLine[INDEX_TURN_RATE], 4), //换手率

    //maXx
    ma5: value_ma(MA[INDEX_MA5], 4),
    ma10: value_ma(MA[INDEX_MA10], 4),
    ma20: value_ma(MA[INDEX_MA20], 4),
    ma55: value_ma(MA[INDEX_MA55], 4),
    ma89: value_ma(MA[INDEX_MA89], 4),
    ma155: value_ma(MA[INDEX_MA144], 4),
    ma233: value_ma(MA[INDEX_MA233], 4),
    ma377: value_ma(MA[INDEX_MA377], 4),
    ma450: value_ma(MA[INDEX_MA450], 4),
    ma610: value_ma(MA[INDEX_MA610], 4),

    //macd_xx
    macd: value_x(MACD[INDEX_MACD_MACD], 4),
    dif: value_x(MACD[INDEX_MACD_DIF], 4),
    dea: value_x(MACD[INDEX_MACD_DEA], 4),

    //kdj_xx
    k: value_x(KDJ[INDEX_KDJ_K], 4),
    d: value_x(KDJ[INDEX_KDJ_D], 4),
    j: value_x(KDJ[INDEX_KDJ_J], 4),

    //其它数据

    // index: -1,
    // name: "-",

    // // buyPrice: 0, //买入价（TODO:废除）
    // // sellPrice: 0, //卖出价（TODO:废除）

    // // 昨日价格: 高、开、低、收
    // prevHighest: 0,
    // prevOpen: 0,
    // prevLowest: 0,
    // prevClose: 0, // 昨日收盘价

    // chgPrice: 0, //涨跌额
    // chgRate: 0, //涨跌幅

    // action: 0 //操作
  };

  return R;
}

// // KLines
// function TKLines(list, startIndex) {
//   var R = [];
//   startIndex = startIndex > 0 ? startIndex : 0;
//   XUtils.forEach(list, function(rawData, i) {
//     var K = TKLine(rawData);
//     K = fixKLine(K, startIndex + i, R[i - 1]);
//     R.push(K);
//   });
//   return R;
// }

// function TKQuestion(rawData) {
//   var R = {
//     kid: 0,
//     stockName: "",
//     stockCode: "",
//     innerCode: "",
//     questionType: 0,
//     questionBody: [],
//     startDate: "",
//     ctime: "",
//     mtime: ""
//   };
//   R = XUtils.assign(R, rawData);
//   R.innerCode = R.innerCode || R.stockCode || "";
//   R.stockCode = R.innerCode.replace(/\.\w+/, "");
//   R.rankNo = R.kidTotal - R.kidLowTotal;
//   //console.log("rankNo : " + [R.rankNo, R.kidTotal , R.kidLowTotal]);
//   return R;
// }

// // 修正统计
// function fixKLine(Today, index, Yesterday) {
//   index = XUtils.isNumber(index) && index >= 0 ? index : -1;
//   Today.index = index;
//   if (index >= 0) {
//     Today.name = "第" + (index + 1) + "天";
//   }

//   var prevClose, currClose;
//   if (Yesterday) {
//     prevClose = Yesterday.close;
//     currClose = Today.close;
//     Today.chgPrice = fixNumber(currClose - prevClose, 2);
//     Today.chgRate = fixNumber(Today.chgPrice / prevClose, 4);
//     Today.prevHighest = Yesterday.highest;
//     Today.prevOpen = Yesterday.open;
//     Today.prevLowest = Yesterday.lowest;
//     Today.prevClose = prevClose;
//   }
//   return Today;
// }
